module.exports = __webpack_public_path__ + "static/ec-dor-desktop-5b574534b1f39037b755c797bfaa1851.png";